export const view = {
	label: {
		countertopProperties: 'Countertop Properties',
		customerPresentation: 'Customer Presentation Mode',
		enterFullscreen: 'Enter Fullscreen Mode',
		exitFullscreen: 'Exit Fullscreen Mode',
		kitchenProperties: 'Kitchen Properties',
		renderingProperties: 'Rendering',
		toggleGrid: 'Toggle Grid'
	},
	tooltip: {
		countertopProperties: 'Click to open Countertop Properties',
		kitchenProperties: 'Click to open Kitchen Properties',
		renderingProperties: 'Click to open Rendering Panel',
		onlyOnComponent: 'Only available in Blueprint and 3D views',
		enterFullscreen: 'Click to enter fullscreen mode',
		exitFullscreen: 'Click to exit fullscreen mode',
		naFullscreen: 'Not available in fullscreen mode',
		showGrid: 'Show Grid',
		hideGrid: 'Hide Grid'
	},
	message: {
	}
};
